import React from 'react';

const ExpenseListTable = ({ expenses, onEdit, onDelete, userProfile, getPayerDisplay, getPaymentStyle }) => {
    return (
        <div style={{ backgroundColor: 'var(--color-glass-strong)', borderRadius: '16px', boxShadow: '0 18px 36px rgba(30, 70, 90, 0.12)', border: '1px solid var(--color-border)', overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead style={{ backgroundColor: 'var(--color-primary-soft)', borderBottom: '2px solid var(--color-primary-soft)' }}>
                    <tr>
                        <th style={{ padding: '15px', textAlign: 'left', color: 'var(--color-primary)', whiteSpace: 'nowrap' }}>วันที่</th>
                        <th style={{ padding: '15px', textAlign: 'left', color: 'var(--color-primary)', whiteSpace: 'nowrap' }}>ผู้จ่าย</th>
                        <th style={{ padding: '15px', textAlign: 'left', color: 'var(--color-primary)', whiteSpace: 'nowrap' }}>บันทึก</th>
                        <th style={{ padding: '15px', textAlign: 'right', color: 'var(--color-primary)', whiteSpace: 'nowrap' }}>จำนวนเงิน</th>
                    </tr>
                    </thead>
                    <tbody>
                    {expenses.map((item) => {
                        const paymentStyle = getPaymentStyle(item.payment_method_id ?? item.payment_method);
                        const isCreatedByMe = item.user_id === userProfile?.userId;
                        return (
                        <tr 
                            key={item.id} 
                            style={{ borderBottom: '1px solid var(--color-surface-muted)', cursor: 'pointer' }}
                            onClick={() => onEdit(item)}
                        >
                        <td style={{ padding: '15px', color: 'var(--color-text-muted)', whiteSpace: 'nowrap' }}>
                            <div>{new Date(item.occurred_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })}</div>
                            {!isCreatedByMe && <div style={{ fontSize: '10px', color: 'var(--color-accent)', marginTop: '2px' }}>โดย {item.creator?.display_name || 'เพื่อน'}</div>}
                        </td>
                        <td style={{ padding: '15px', color: 'var(--color-text-muted)', fontWeight: '500', whiteSpace: 'nowrap' }}>
                            {getPayerDisplay(item)}
                        </td>
                        <td style={{ padding: '15px', fontWeight: '500', color: 'var(--color-text)', minWidth: '100px' }}>
                            <div>{item.note || '-'}</div>
                            {item.trips && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '4px', padding: '2px 8px', backgroundColor: 'var(--color-accent-soft)', borderRadius: '12px', fontSize: '11px', color: 'var(--color-accent)' }}>
                                    <span>{item.trips.icon || '✈️'}</span> {item.trips.name}
                                </div>
                            )}
                        </td>
                        <td style={{ padding: '15px', textAlign: 'right', fontWeight: 'bold', color: paymentStyle.color, whiteSpace: 'nowrap' }}>
                            {item.amount.toLocaleString()} {item.currency}
                            {paymentStyle.icon}
                        </td>
                        </tr>
                    );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ExpenseListTable;
